export const CHANGE_STATE = 'CHANGE_STATE'

export const HANDLE_DELETE = 'HANDLE_DELETE'